import { ToBaseUnit } from '../inputs/UnitConversion';
import deepEqual from './DeepEqual';

function handleInputChange(
  name,
  value,
  inputs,
  setInputs,
  setOptions,
  setCurrentSpiralMenu = null,
  meta = {}
) {
  if (
    ['lower_end_double_bend', 'upper_end_double_bend', 'guide_plate'].includes(
      name
    ) &&
    value === null
  ) {
    value = false;
  } else if (['track'].includes(name) && value === null) {
    value = inputs.track;
  }

  const { unit } = meta;
  value = ToBaseUnit(value, unit);

  if (
    ['distance_flanged_plinth_below_le', 'distance_split_above_le'].includes(
      name
    )
  ) {
    value = String(value);
  }

  if (
    [
      'u2',
      'u2_value',
      'upper_end_double_bend',
      'return_channel',
      'u1_extension',
      'connection_machine_ue',
      'machine_ref_ue',
    ].includes(name) &&
    setCurrentSpiralMenu !== null &&
    setCurrentSpiralMenu !== undefined
  ) {
    setCurrentSpiralMenu('upper-end');
  } else if (
    [
      'l2',
      'l2_value',
      'l1_extension',
      'lower_end_double_bend',
      'special_le_slope',
      'connection_machine_le',
      'machine_ref_le',
    ].includes(name) &&
    setCurrentSpiralMenu !== null &&
    setCurrentSpiralMenu !== undefined
  ) {
    setCurrentSpiralMenu('lower-end');
  }

  if (!deepEqual(inputs[name], value)) {
    setOptions((options) =>
      options.map((option) =>
        option.field === name ? { ...option, value: value } : option
      )
    );

    switch (name) {
      case 'sv_family':
        setInputs((prevInputs) => ({
          ...prevInputs,
          sv_family: value,
          machine_type: null,
        }));
        break;

      case 'machine_type':
        const parts = value?.split('-') ?? [];
        const isSVL = value?.startsWith('SV-L-');
        const sv_fam = isSVL ? 'SV-L' : parts[0];
        const trackValue = { 1: isSVL ? parts[2] : parts[1] };
        if (trackValue && sv_fam)
          setInputs((prevInputs) => ({
            ...prevInputs,
            track:
              sv_fam === 'SV' || sv_fam === 'SVs' || sv_fam === 'SV-L'
                ? trackValue
                : {},
            sv_family: sv_fam,
            machine_type: value === '' ? null : value,
          }));
        break;

      case 'h2':
        setInputs((prevInputs) => ({
          ...prevInputs,
          h3: null,
          h2: value,
        }));
        break;

      case 'h3':
        setInputs((prevInputs) => ({
          ...prevInputs,
          h2: null,
          h3: value,
        }));
        break;

      case 'l2':
        setInputs((prevInputs) => ({
          ...prevInputs,
          l2_value: value === false ? 0 : prevInputs.l2_value,
          l2: value,
        }));
        break;

      case 'u2':
        setInputs((prevInputs) => ({
          ...prevInputs,
          u2_value: value === false ? 0 : prevInputs.u2_value,
          u2: value,
        }));
        break;

      case 'transfer_side':
        setInputs((prevInputs) => ({
          ...prevInputs,
          u2_value: value === 'Side transfer' ? null : prevInputs.u2_value,
          l2_value: value === 'Side transfer' ? null : prevInputs.l2_value,
          transfer_side: value,
        }));
        break;

      case 'gearmotor_type':
        setInputs((prevInputs) => ({
          ...prevInputs,
          drive: value === 'no motor' ? {} : prevInputs.drive,
          gearmotor_type: value === '' ? null : value,
        }));
        break;

      case 'voltage_movimot':
        setInputs((prevInputs) => ({
          ...prevInputs,
          voltage_50_hz: null,
          voltage_60_hz: null,
          voltage_movimot: value === '' ? null : value,
        }));
        break;

      case 'voltage_50_hz':
        setInputs((prevInputs) => ({
          ...prevInputs,
          voltage_movimot: null,
          voltage_60_hz: null,
          voltage_50_hz: value === '' ? null : value,
        }));
        break;

      case 'voltage_60_hz':
        setInputs((prevInputs) => ({
          ...prevInputs,
          voltage_movimot: null,
          voltage_50_hz: null,
          voltage_60_hz: value === '' ? null : value,
        }));
        break;

      case 'ml_pre_treatment':
        setInputs((prevInputs) => ({
          ...prevInputs,
          connection_conveyor: value ? prevInputs.connection_conveyor : null,
          ml_pre_treatment: value === '' ? null : value,
        }));
        break;

      case 'speed_range':
        setInputs((prevInputs) => ({
          ...prevInputs,
          centerline_speed:
            !value || value === 'customized'
              ? prevInputs.centerline_speed
              : null,
          speed_range: value === '' ? null : value,
        }));
        break;

      case 'product_flow':
        setInputs((prevInputs) => {
          if (value !== 'mass flow') {
            return {
              ...prevInputs,
              product_flow: value,
            };
          }
          const updatedProductTbh = (prevInputs.product_tbh || []).map(
            (product) => ({
              ...product,
              throughput: null,
            })
          );
          return {
            ...prevInputs,
            product_flow: value,
            product_tbh: updatedProductTbh,
          };
        });
        break;

      default:
        setInputs((prevInputs) => ({
          ...prevInputs,
          [name]: value === '' ? null : value,
        }));
        break;
    }
  }
}

export default handleInputChange;
